import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoggingUtilsService {
  constructor() {
  }

  logToSupportEscalationsSlack(title: string, data: any) {
    // data = JSON.stringify(data);
    // // ** log a payload to slack
    // var url = "https://hooks.slack.com/services/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";
    // var applicname = (('undefined' !== survey.data["FirstName"]) ? survey.data["FirstName"] + ' ' + survey.data["LastName"] + ' (' + survey.data["emailaddress"] + ')' : 'a user')
    // var text = `${title} \n\n ${applicname} was completing ${form_source} (rhid: ${RESPONSE_HEADER_ID} env: ${ENV}) : \n\n Logged Payload : \`${data}\``;
    //
    // return postApi(url, JSON.stringify({ "text": text }), null, () => { }, () => { }, survey)
  }

  async postHelpdeskTicketToAssociation(subject: string, message: string) {
    // Create new endpoint in utilities service to create a helpdesk ticket that uses the fixed values directly
    /*const body = {
      first_name: survey.getValue('FirstName'),
      last_name: survey.getValue('LastName'),
      email: survey.getValue('emailaddress'),
      subject,
      message
    }

    // Post ticket to /submit_form_helpdesk_ticket
    return postApi(`${uapi}/utilities/v1/helpdesk/submit_form_helpdesk_ticket`, body, UTILITIES_API_TOKEN, () => { }, ApiGetError, survey)*/
  }
}
